import type { v3Env } from '@/config/types';
import env = Tachikoma.env;

export const dataTrackHost = 'https://data-track.corp.kuaishou.com';
export const overseaDataTrackHost = 'https://data-track-sgp.corp.kuaishou.com';
const testHost = dataTrackHost + '/';

export const PROD = 'production';
const TEST = 'test';
const DEV = 'development';
const OVERSEA = 'oversea';
export const LOGGER = 'logger';
export const LOGGER_SGP = 'logger-oversea';

const v3Api = 'rest/wd/common/log/collect/';
export const Envs = [PROD, TEST, DEV, LOGGER, OVERSEA];
const overseaHost = 'https://logsdk.kwai-pro.com/';
export const Apis = {
    // v2 接口一定要带上 _json=1 参数，不然服务端会解析失败
    v2: `rest/kd/log/collect?_json=1&biz=`,
    v3: `${v3Api}misc2`,
    // 雷达都上报到 v3
    radar: `${v3Api}radar`
};

export const Hosts = {
    v2: {
        // 正式环境随机域名分流
        production: ['https://wlog.ksapisrv.com/', 'https://wlog.gifshow.com/'][Math.round(Math.random())],
        development: testHost,
        test: testHost,
        oversea: overseaHost
    },
    v3: {
        production: 'https://log-sdk.ksapisrv.com/',
        development: testHost,
        test: testHost,
        oversea: overseaHost
    }
};

export const NodeHosts = {
    v2: {
        // 正式环境随机域名分流
        production: ['https://wlog.ksapisrv.com/', 'https://wlog.gifshow.com/'][Math.round(Math.random())],
        development: testHost,
        test: testHost,
        oversea: overseaHost
    },
    v3: {
        production: 'https://log-sdk-internal.corp.kuaishou.com/',
        development: testHost,
        test: testHost,
        oversea: overseaHost
    }
}

export const buildUrl = (
    env: string = PROD,
    radar = false,
    proto: 'v2' | 'v3' = 'v3',
) => {
    if (Envs.indexOf(env) === -1) {
        return env + Apis[proto];
    }
    if (radar && Hosts.v3[env as v3Env]) {
        return Hosts.v3[env as v3Env] + Apis.radar;
    }
    if (Hosts[proto][env as v3Env] && Apis[proto]) {
        return Hosts[proto][env as v3Env] + Apis[proto];
    }
    return Hosts.v3.production + Apis.v3;
};

export const nodeBuildUrl = (
    env: string = PROD,
    radar = false,
    proto: 'v2' | 'v3' = 'v3',
) => {
    if (Envs.indexOf(env) === -1) {
        return env + Apis[proto];
    }
    if (radar && NodeHosts.v3[env as v3Env]) {
        return NodeHosts.v3[env as v3Env] + Apis.radar;
    }
    if (NodeHosts[proto][env as v3Env] && Apis[proto]) {
        return NodeHosts[proto][env as v3Env] + Apis[proto];
    }
    return NodeHosts.v3.production + Apis.v3;
}

export const formatUrlQuery = (url: string, querys: string) => {
    if (!querys) return url;
    let reg = /\?(.+?)$/;
    try {
        return reg.test(url) ? url.replace(/\?(.+?)$/, `?${querys}&$1`) : url + `?${querys}`;
    } catch (err) {
        return url;
    }
};
